import { AIAgent } from "@graylog/enterprise-api";
const fetchWorkflowRunSlices = (column, _query, _filters) => AIAgent.runsSlices(column);
export default fetchWorkflowRunSlices;
